<template>
  <div
    class="header_sp"
    @click="motion()">
    <div class="header_sp__btn">
      <span class="header_sp__btn_line"/>
      <span class="header_sp__btn_line"/>
      <span class="header_sp__btn_line"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HeaderSp',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['navState'])
  },
  methods: {
    motion: function () {
      this.$store.dispatch('changeNavState')
    }
  },
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="postcss" scoped>
  @import '../../assets/css/mixins.css';
  @import '../../assets/css/variables.css';
  .header_sp {
    display: flex;
    width: 50px;
    height: 50px;
    transform: translate3d(0,0,0);
    color: #FFFFFF;
    background: rgba(204, 52, 84, 0.8);
    z-index: 1000;
    &__btn {
      position: relative;
      margin: 16px 14px;
      &_line {
        position: absolute;
        width: 22px;
        height: 2px;
        background: #FFFFFF;
        transition: .35s ease-in-out;
      }
      &_line:nth-child(1) {
        top: 0;
      }
      &_line:nth-child(2) {
        top: 8px;
      }
      &_line:nth-child(3) {
        top: 16px;
      }
      &_line.is-active:nth-child(1) {
        top: 7px;
        left: 0px;
        transform: rotate(-45deg);
      }
      &_line.is-active:nth-child(2),
      &_line.is-active:nth-child(3) {
        top: 7px;
        transform: rotate(45deg);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/organisms/HeaderSp.vue